import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Language {
  constructor(private translate: TranslateService) {
    this.translate.addLangs(['en', 'nl']);
    const savedLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.setFallbackLang('en');
    this.translate.use(savedLang);
  }

  private languageChanged = new BehaviorSubject<string>(
    localStorage.getItem('selectedLanguage') || 'en',
  );

  changeLanguage(lang: string) {
    if (!lang) return;
    localStorage.setItem('selectedLanguage', lang);
    this.translate.use(lang);
    this.languageChanged.next(lang);
  }

  getLanguage() {
    const language = localStorage.getItem('selectedLanguage');

    return language || 'en';
  }
}
